import type { TFunction } from "i18next";

/* The application name and tagline are admin-set (Theme Settings). Until an admin changes
   them they equal these English defaults, and the defaults are translated with the rest of
   the console; anything the admin typed is shown exactly as typed. */
export const DEFAULT_APP_NAME = "E-Invoicing Hub";
export const DEFAULT_TAGLINE = "Group console";

export function brandName(t: TFunction, appName: string | undefined): string {
  return !appName || appName === DEFAULT_APP_NAME ? t("brand.name", DEFAULT_APP_NAME) : appName;
}

export function brandTagline(t: TFunction, tagline: string | undefined): string {
  return tagline === undefined || tagline === DEFAULT_TAGLINE ? t("brand.subHub", DEFAULT_TAGLINE) : tagline;
}
